/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-03-20 15:49:58
 * @LastEditors: changfeng
 * @LastEditTime: 2023-03-20 16:04:54
 */
export default {
  'copy.campaign.target': '推广目标',
  'copy.copyTo': '复制到',
  'copy.campaign.exist': '已有的推广系列',
  'copy.campaign.new': '新建推广系列',
  'copy.campaign.choose campaign': '请选择推广系列',
};
